<section class="jumbotron">
  <div class="container position-relative">
    <div class="jumbotron-content text-white text-center">
      <h1 class="font-weight-bolder text-title-header">{{'header.environment' | translate}}</h1>
      <span class="italic-title"><i>Smart City</i> </span> <br>
      <img src="../../../../assets/img/SOLUCIÓN/MEDIO AMBIENTE/01.svg" alt="">
    </div>
  </div>
</section>
<section class="bg-green-qaira">
  <div class="container py-4 text-center text-white">
      <p class="p-subtitle">{{'solution.smart_city_text' | translate}}</p>
      <ul class="text-left p-subtitle" style="display: inline-grid;">
        <li >{{'solution.smart_li1' | translate}}</li>
        <li >{{'solution.smart_li2' | translate}}</li>
        <li >{{'solution.smart_li3' | translate}}</li>
        <li >{{'solution.smart_li4' | translate}}</li>
      </ul>
  </div>
</section>
<section class="bg-white">
  <div class="container py-4 text-center mb-4">
    <h1 class="text-blue-qaira font-weight-bolder">qHAWAX</h1>
    <p class="mb-4 p-subtitle text-center">{{'solution.smart_qhawax_sub' | translate}}</p>
    <img class="img-iso" src="../../../../assets/img/SOLUCIÓN/MEDIO AMBIENTE/logo solar impulse.svg" alt="">
    <p class="mb-5 p-subtitle">{{'solution.smart_qhawax_text' | translate}}</p>
    <a class="btn custom-cta border-btn mr-2" href="{{'solution.brochure_qhawax' | translate}}" target="_blank">{{'app.download' | translate}}</a>
    <!-- <input class="btn custom-cta bg-yellow-qaira" (click)="viewVideo('https://youtu.be/0YqGAWmsv-U')" type="button" value="Ver Video"> -->
  </div>
  <div class="container text-center mb-2">
    <img width="80%" src="../../../../assets/img/qhawax.png" alt="">
  </div>
</section>

<section>
  <div class="container py-4 text-center mb-4">
    <h1 class="text-green-qaira font-weight-bolder">qHAWAX-in</h1>
    <p class="mb-4 p-subtitle text-center">{{'solution.smart_qhawax_sub_in' | translate}}</p>
    <p class="mb-5 p-subtitle">{{'solution.smart_qhawax_text_in' | translate}}</p>
    <a class="btn custom-cta border-btn mr-2" href="{{'solution.brochure_qhawax_in' | translate}}" target="_blank">{{'app.download' | translate}}</a>
    <!-- <input class="btn custom-cta bg-yellow-qaira" (click)="viewVideo('https://youtu.be/0YqGAWmsv-U')" type="button" value="Ver Video"> -->
  </div>
  <div class="container text-center mb-2">
    <img width="50%" id="qh-in" src="../../../../assets/img/INICIO/qHAWAX_in.svg" alt="">
  </div>
</section>


<section class="bg-green-qaira">
  <div class="container py-3 text-white">
    <div class="row">
      <div class="col-lg-4 py-5">
        <h1 class="mt-4 font-weight-bolder">Software <br> qAIRamap</h1>
        <p>{{'solution.smart_qmap_sub' | translate}}</p>
      </div>
      <div class="col-lg-7">
        <img style="width: 100%;" src="../../../assets/img/INICIO/laptop-y-celular-qairamap.png" alt="">
      </div>
    </div>
  </div>
</section>
<section style="background: url(../../../../assets/img/fondo.png);background-repeat: no-repeat;
              background-size: cover;">
  <div class="container py-4">
    <ul class="text-white text-white p-subtitle">
      <li>{{'solution.smart_qmap_text1' | translate}}</li>
      <li>{{'solution.smart_qmap_text2' | translate}}</li>
      <li>{{'solution.smart_qmap_text3' | translate}}</li>
      <li>{{'solution.smart_qmap_text4' | translate}}</li>
    </ul>
  </div>
</section>
<!-- <section class="bg-white">
  <div class="container py-1"></div>
</section> -->
<section class="section-img-custom text-white">
  <div class="container py-4 text-center">
    <h1>{{'app.questions' | translate}}</h1>
    <p>{{'app.questions_sub' | translate}}</p>
      <a class="btn custom-cta" [routerLink]="['/contacto']">{{'app.contact_us' | translate}}</a>
  </div>
</section>
